import * as XLSX from "xlsx";

export const ExtractExcelFileData = async (file) => {
    try {
        const reader = new FileReader();

        return new Promise((resolve, reject) => {
            reader.onload = (e) => {
                try {
                    const binaryString = e.target.result;
                    const wb = XLSX.read(binaryString, { type: "binary" });
                    const sheet = wb.Sheets[wb.SheetNames[0]]; // Get first sheet
                    const jsonData = XLSX.utils.sheet_to_json(sheet, {
                        header: 1, // Use first row as header
                        raw: false,
                        defval: "", // Default value for empty cells
                    });

                    const headers = jsonData[0];
                    const data = jsonData.slice(1);

                    // Resolve with both headers and data
                    resolve({ headers, data });
                } catch (error) {
                    reject(error); // Handle any errors during parsing
                }
            };

            reader.onerror = (error) => reject(error); // Handle file reader error
            reader.readAsBinaryString(file);
        });
    } catch (error) {
        console.error("Error processing file upload", error);
        throw error; // Re-throw to handle in the calling component
    }
};
